module.exports = __webpack_public_path__ + "img/box_senior.7b135561.png";